import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { sortOption as sortOptions } from '../../constants/youtube';
import * as KEY from '@/constants/keyCode';

function SearchOption ({
  sortOption, openSortLayer, closeSortLayer,
  isSortLayerOpen, updateSortOption, searchVideos,
}) {
  const [selectedIdx, setSelectedIdx] = useState(0);

  const menuRef = useRef(null);
  const openBtnRef = useRef(null);

  let timeoutId = null;

  return (
    <div onFocus={handleFocus} onBlur={handleBlur} className={`opt_comm ${isSortLayerOpen ? 'opt_open' : ''}`}>
      <div className="screen_out">카테고리 선택상자</div>
      <span className="screen_out">선택내용 : </span>
      <a href="#" role="button" onClick={toggleLayer} className="link_selected"
        ref={openBtnRef} aria-haspopup="true" aria-expanded={isSortLayerOpen}>
        <span>{sortOptions[sortOption].TXT}</span>
        <span className="img_common_tistory ico_arrow"></span>
      </a>
      <div className="screen_out">선택옵션</div>
      <div className="wrap_opt">
        <ul className="list_opt" role="menu" ref={menuRef} onKeyDown={handleKeyDown}>
          {Object.entries(sortOptions).map(([key, { TXT, VAL }], index) => (
            <li
              key={key}
              role="menuitem"
              aria-label={TXT}
              className={selectedIdx === index ? 'mce-active' : ''}
              tabIndex={selectedIdx === index ? 0 : -1}
              onClick={() => handleItemClick(VAL)}
              onMouseOver={() => setSelectedIdx(index)}
            >
              <span className="link_select">{TXT}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );


  function handleFocus () {
    clearTimeout(timeoutId);
  }

  function handleBlur () {
    timeoutId = setTimeout(() => closeSortLayer());
  }

  function handleItemClick (value) {
    updateSortOption(value);
    searchVideos();
    closeSortLayer();
  }

  function toggleLayer () {
    if (isSortLayerOpen) {
      closeSortLayer();
      return;
    }
    openSortLayer();
    setSelectedIdx(0);
    setTimeout(() => {
      menuRef.current.childNodes[0].focus();
    });
  }

  function handleKeyDown (event) {
    const menuItems = menuRef.current.childNodes;
    const len = Object.keys(sortOptions).length;

    const prevIdx = (selectedIdx + len - 1) % len;
    const nextIdx = (selectedIdx + 1) % len;

    switch (event.keyCode) {
      case KEY.ARROW_UP:
        setSelectedIdx(prevIdx);
        menuItems[prevIdx].focus();
        break;
      case KEY.ARROW_DOWN:
        setSelectedIdx(nextIdx);
        menuItems[nextIdx].focus();
        break;
      case KEY.ESC:
        closeSortLayer();
        setTimeout(() => openBtnRef.current.focus());
        break;
      case KEY.SPACE: case KEY.ENTER:
        updateSortOption(Object.keys(sortOptions)[selectedIdx]);
        searchVideos();
        closeSortLayer();
        setTimeout(() => openBtnRef.current.focus());
        break;
      case KEY.TAB:
        closeSortLayer();
        break;
      default:
        break;
    }
  }
}

SearchOption.propTypes = {
  sortOption: PropTypes.string,
  openSortLayer: PropTypes.func,
  closeSortLayer: PropTypes.func,
  isSortLayerOpen: PropTypes.bool,
  updateSortOption: PropTypes.func,
};

export default SearchOption;
